import React, { useRef } from 'react';
import OneFamVideo from '../../videos/one-fam-trailer.mp4';
import PosterImage from '../../images/one-fam-video-poster.png';
import './index.scss';
import { sections } from '../header';
import { StaticImage } from 'gatsby-plugin-image';
import { Analytics, logEvent } from 'firebase/analytics';
import { analytics } from '../../utilities/firebase';

export interface LandingProps {
  handleNavigateLink: (id: string) => void;
}

const Landing = React.forwardRef<HTMLDivElement, LandingProps>(function Landing(
  { handleNavigateLink },
  ref
) {
  const videoRef = useRef<HTMLVideoElement>(null);

  const onBookClick = () => {
    const firebaseAnalytics = analytics();
    if (firebaseAnalytics) {
      logEvent(firebaseAnalytics, 'book_appointment', { name: 'landing-page' });
    }
    location.href = 'https://getsquire.com/booking/brands/onefam';
  };

  return (
    <section id='landing' key='landing-section' ref={ref}>
      <div className='landing-navigation'>
        <header>
          <StaticImage
            objectFit='contain'
            className='logo'
            height={90}
            layout='fixed'
            src='../../images/one-fam-full-logo.svg'
            alt='ONEFAM Logo'
            placeholder='none'
          />
        </header>
        <nav>
          {sections.map((section) => (
            <div
              key={`landing-link-${section.id}`}
              id={`landing-link-${section.id}`}
              onClick={() => handleNavigateLink(section.id)}
            >
              {section.title}
            </div>
          ))}
        </nav>
      </div>
      <div className='video-container'>
        <video
          ref={videoRef}
          id='background-video'
          loop
          autoPlay
          preload='auto'
          muted
          playsInline
          poster={PosterImage}
        >
          <source src={OneFamVideo} type='video/mp4' />
          <source src={OneFamVideo} type='video/ogg' />
          Your browser does not support the video tag.
        </video>
        <div className='video-filter'></div>
      </div>
      <div className='content-container'>
        <div className='landing-text-container'>
          <p
            data-sal='slide-up'
            data-sal-duration='500'
            data-sal-easing='ease-in-out'
          >
            “integrate the culture
          </p>
          <p
            data-sal='slide-up'
            data-sal-duration='500'
            data-sal-easing='ease-in-out'
            data-sal-delay='200'
          >
            &nbsp;&nbsp;into the community.”
          </p>
        </div>
        <button
          className='outline-white'
          onClick={onBookClick}
          data-sal='slide-up'
          data-sal-duration='500'
          data-sal-easing='ease-in-out'
        >
          <span>
            book your
            <br />
            appointment
          </span>
        </button>
      </div>
    </section>
  );
});

export default Landing;
